var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(_vm.wrapperName,{tag:"component",attrs:{"question":_vm.question,"selected":_vm.selected,"validation":_vm.validationStatus},on:{"update-answer":_vm.handleAnswer}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }